module.exports = __webpack_public_path__ + "img/tranquility.92ef1d17.png";